import { memo, useCallback } from 'react';
import { BzButton, BzCard, BzHeading, BzInputText, BzModal } from "../../../components";
import { Container, Row, Col, InputGroup } from "react-bootstrap";
import { handleModal } from "../../../redux/actions/modals";
import { useDispatch, useSelector } from 'react-redux';


const CreateWatchlistModal = ({ newWatchlistName, setNewWatchlistName, globalWatchlists, globalWatchlistTemplateModalToggle, onCreateNewCustomWatchlist, ...props }) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);

    const createCustomWatchlistOnClickHandler = useCallback(() => {
        onCreateNewCustomWatchlist(newWatchlistName);
    }, []);
    const handleClose = () => {
        dispatch(handleModal([{ "CREATE_WATCHLIST": false }]));
    };
    const handleOnChange = (e) => {
        setNewWatchlistName(e.target.value);
    };


    return (
        <BzModal size='lg' show={modals['CREATE_WATCHLIST']} onHide={handleClose}>
            <Container fluid className='p-0'>

                <Row className='g-0 ps-5 pe-3 pt-5'>
                    <Col className='flex-column justify-content-start align-self-center'>
                        <BzHeading className='font-medium font-size8 color-text pb-2'>Let's create your first watchlist!</BzHeading>
                        <div className='font-regular font-size3 color-text'>Keep watching them to find right opportunities.</div>
                    </Col>
                    <Col md={2} className='d-flex justify-content-end align-self-start'>
                        <BzButton onClick={handleClose} className='btn btn-sm btn-outline btn-rounded'>Skip</BzButton>
                    </Col>
                </Row>

                <Row className='g-0 ps-5 pe-5 pt-5'>
                    <Col>
                        <BzHeading className='font-medium font-size3 color-text'>Choose from these top picks</BzHeading>
                        <div className='mutual-funds-watchlist-card-wrap'>
                            {globalWatchlists?.map((each, i) =>
                                <BzCard className='mutual-funds-watchlist-card cursor-pointer' key={i} onClick={() => { globalWatchlistTemplateModalToggle(each); }}>
                                    <Row className='g-0'>
                                        <Col className='mutual-funds-watchlist-img'>
                                            <div className='watchlist-img-0'></div>                                         
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mt-2'>
                                        <Col className='mutual-funds-watchlist-info'>
                                            <div className='font-regular font-size1 color-subtext text-uppercase'>TOP 20</div>
                                            <div className='font-medium font-size3 color-text pt-1'>{each.name}</div>
                                        </Col>
                                    </Row>

                                    {/* 
                                    
                                        Subscribers section is not in Latest Design

                                        <Row className='g-0'>
                                            <Col className='d-flex justify-content-start align-items-center'>
                                                <div className='icon-12 icon-dark icon-subscribers me-2'></div>                                     
                                                <div className='font-regular font-size2 color-subtext'>Subscribers</div>
                                            </Col>
                                        </Row> 
                                        
                                    */}


                                </BzCard>
                            )}
                        </div>
                    </Col>
                </Row>

                <Row className='g-0 ps-5 pe-5 py-4'>
                    <Col>
                        <Row className='g-0'>
                            <Col>
                                <div className='fancyline'>
                                    <span className='font-medium font-size3 color-text'>Or you can create your own watchlist</span>
                                </div>
                            </Col>
                        </Row>
                        <Row className='g-0'>
                            <Col md={6} className='mx-auto'>
                                <InputGroup className='py-4'>
                                    <BzInputText className='font-regular font-size2 color-text' placeholder='Name your watchlist' value={newWatchlistName} onChange={handleOnChange} />
                                    <BzButton className='btn btn-sm btn-primary text-capitalize' onClick={createCustomWatchlistOnClickHandler}>Create</BzButton>
                                </InputGroup>
                            </Col>
                        </Row>
                    </Col>
                </Row>

            </Container>
        </BzModal>

    );
};

export default memo(CreateWatchlistModal);